import { F_QUARTERS } from 'partner360/configs'

import { PLANNING_BY_FY_FQ } from '../config'

import { calcSoBOverallForQuarter, ICalcSoBOverallForQuarter } from './calcSoBOverallForQuarter'

/**
 * Calc SoB Overall for Quarter / all Quarters by SubCategories
 */
export const calcSoBCategoryOverallForCategory = (props: ICalcSoBOverallForQuarter) => {
  let data = [...props.items]

  const isCalcSobForQuarters =
    props.fq === PLANNING_BY_FY_FQ && (props.fy === props.fyear || props.fy === props.fyear - 1)

  if (isCalcSobForQuarters && !props.isYearlyPlanning) {
    F_QUARTERS.forEach((q) => {
      const qProps = { ...props, items: data, fq: q }
      data = calcSoBOverallForQuarter(qProps)
    })
  } else {
    data = calcSoBOverallForQuarter(props)
  }

  return data
}
